<div class="dash-section m-5 bg-white">
  <div class="m-4">&nbsp;</div>
  <div class="m-4 row">
    <div class="col">
      <span class="float-left">
        &nbsp; &nbsp; &nbsp; &nbsp;Market Info On The App
      </span>
    </div>
    <div class="col">
      <button
        class="float-right btn bg-primary text-white mx-3"
        data-toggle="modal"
        data-target="#uploadModal"
      >
        <i class="fas fa-plus mr-2"></i>Upload Market Info
      </button>
    </div>
  </div>
  <div class="m-4">&nbsp;</div>
  <!-- <div class="alert alert-danger" *ngIf="errors">{{ errors }}</div> -->
  <!-- <table class="table table-striped ">
    <thead w-100 class="table_head"></thead> -->
    <p-table #diagnosisT
    [value]="inputs" 
    [paginator]="true"
    [rows]="10" 
    [loading]="loading"
    [rowsPerPageOptions]="[10,20,30,40,50]"
    class="table table-striped table-hover"
    >
    <ng-template pTemplate="header" class="table_head">
      <tr>
        <th scope="col" style="width: 40px; background-color: rgb(89, 170, 233);color: white;">#</th>
        <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Date</th>
        <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Crop</th>
        <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Average Retail Price(UGX)</th>
        <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Average WholeSale Price(UGX)</th>
        <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Action</th>
      </tr>
      <tr>
        <th></th>
        <th></th>
        <th>
          <p-multiSelect
            id="selectcrop"
            #selectcrop="ngModel"  
            [(ngModel)]="selectedCrops" 
            [options]="selectCrop" 
            defaultLabel="All Crops" 
            (onChange)="diagnosisT.filter($event.value, 'crop', 'in')">
            </p-multiSelect>
        </th>
        <th></th>
        <th></th>
        <th>
          <button
          (click)="Clear(diagnosisT)"
          class="btn btn-md bg-dark disabled text-white clear"
          >
          Clear Filters
          </button>
        </th>
      </tr>
    <!-- </thead>
    <tbody p-5 *ngIf="inputs"> -->
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <!-- *ngFor="
          let row of inputs
            | paginate: { itemsPerPage: count, currentPage: page };
          let i = index
        "
      > -->
        <td>{{ inputs.indexOf(row)+ 1 }}</td>
        <td>{{ row.date }}</td>
        <td>{{ row.crop }}</td>
        <td>{{ row.avg_retail }}</td>
        <td>{{ row.avg_wholesale }}</td>

        <td>
          <div class="dropdown">
            <button
              class="btn btn-outline-info dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              ACTION
            </button>
            <div
              class="dropdown-menu options"
              aria-labelledby="dropdownMenuButton"
            >
              <a
                class="dropdown-item suspend"
                data-toggle="modal"
                data-target="#viewMore"
                (click)="viewDetails(row.crop)"
                >ViewMore</a
              >
              <!-- <a
                class="dropdown-item activate"
                data-toggle="modal"
                data-target="#inputModal"
                (click)="prepareToDeleteInput(row.id, row.name)"
                >Delete</a
              > -->
            </div>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
    <!-- </tbody>
  </table> -->

  <!-- <nav aria-label="Page navigation example">
    <pagination-controls (pageChange)="page = $event"></pagination-controls>
  </nav> -->
  <div class="spinner d-flex" *ngIf="loading">
    <span class="spinner-border spinner-border-md mx-auto update-loading" role="status"></span>
  </div>
  <div class="m-4">&nbsp;</div>
</div>
<!-- Upload New Market Info modal -->
<div class="modal fade" id="uploadModal">
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 50%;">
    <div class="card modal-content">
        <div class="modal-header">
            <h4 class="modal-title text-info" id="modal-basic-title">Upload Market Info</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body agronomical-view-details">
          <div class="container-fluid">
            <form (submit)="uploadMarketInfo()" class="px-2 py-2">
            <div class="form-group">
              <label for="csv">Choose csv file</label>
              <input type="file" accept=".csv" (change)="handleFileSelect($event)" 
              class="form-control change-input-field" name="csv" required/>
            </div>
            <div class="alert alert-danger" *ngIf="errors">{{ errors }}</div>
            <div class="d-flex justify-content-center align-item-center form-group">
              <button class="submit-input-btn btn-success">
                <!-- <span *ngIf="loadingModal" class="spinner-border spinner-border-md
                  text-white change-loading" role="status"></span> -->
                <!-- <span class="text-danger" *ngIf="errors">{{ errors }}</span> -->
                <span *ngIf="loading" class="mx-2">Loading...</span>
                <span *ngIf="!loading">
                  Upload Info
                </span>
              </button>
            </div>
          </form>
            </div>
        </div>
      <!-- <div class="modal-footer">
        <a
        class="btn btn-danger text-white"
        data-dismiss="modal"
        data-toggle="modal"
        data-target="#selectedCropModal"
        (click)="prepareToDeleteInput(selectedCropRecord)"
        >Delete</a
        >
        <button type="button" class="btn btn-warning" data-dismiss="modal">
          <span class="text-white">CLOSE</span>
        </button>
      </div> -->
    </div>
    <app-success-modal
      *ngIf="openSuccessModal && message"
      [message]="message"
      (clearInputEvent)="clearInputId()"
    >
    </app-success-modal>
  </div>
</div>
<!--crop details modal-->
<div class="modal fade" id="viewMore">
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 65%;">
    <div class="card modal-content">
        <div class="modal-header">
            <h4 class="modal-title text-info" id="modal-basic-title" *ngIf="selectedCrop">{{selectedCrop}} Market Details</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
   
        <div class="modal-body agronomical-view-details">
          <div class="container-fluid" *ngIf="cropDetails">
            <table class="table table-striped ">
              <thead w-100 class="table_head">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Date</th>
                  <th scope="col">Market</th>
                  <th scope="col">Retail Price(UGX)</th>
                  <th scope="col">WholeSale Price(UGX)</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody p-5 *ngIf="cropDetails">
                <tr
                  *ngFor="
                    let row of cropDetails
                    let i = index
                  "
                >
                  <td>{{ (page - 1) * count + i + 1 }}</td>
                  <td>{{ row.time }}</td>
                  <td>{{ row.market }}</td>
                  <td>{{ row.retailprice }}</td>
                  <td>{{ row.wholesaleprice }}</td>

                  <td>
                    <div class="dropdown">
                      <button
                        class="btn btn-outline-info dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        ACTION
                      </button>
                      <div
                        class="dropdown-menu options"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a
                          class="dropdown-item suspend"
                          data-toggle="modal"
                          data-target="#updateCropInfo"
                          (click)="viewCropInfo(row)"
                          >Edit/Delete</a
                        >
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-warning" data-dismiss="modal">
          <span class="text-white">CLOSE</span>
        </button>
      </div>
    </div>
    <app-success-modal
      *ngIf="openSuccessModal && message"
      [message]="message"
      (clearInputEvent)="clearInputId()"
    >
    </app-success-modal>
  </div>
</div>
<!--New Edit modal-->
<div class="modal fade" id="updateCropInfo">
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 50%;">
    <div class="card modal-content">
        <div class="modal-header">
            <h4 class="modal-title text-info" id="modal-basic-title">Edit Record</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
   
        <div class="modal-body agronomical-view-details">
          <div class="container-fluid" *ngIf="selectedCropRecord">
            <form *ngIf="selectedCropRecord" (submit)="updateInput(updateInputForm.value, selectedCropRecord.id)" #updateInputForm="ngForm"
            class="px-2 py-2">
            <div class="form-group">
              <label for="market">Market</label>
              <input type="text" class="form-control change-input-field" placeholder="Market" name="market"
                #market="ngModel" [(ngModel)]="selectedCropRecord.market" value="{{ selectedCropRecord.market }}" required minlength="3" />
              <!-- <div *ngIf="market.touched && !market.valid">
                <span *ngIf="market.errors.minlength" class="text-danger change-text-danger">market name mustn't be under 3
                  characters.</span>
              </div> -->
            </div>
            <div class="form-group">
              <label for="retailprice">Retail Price(UGX)</label>
              <input type="text" class="form-control change-input-field" placeholder="Retail Price" name="retailprice" #retailprice="ngModel"
              [(ngModel)]="selectedCropRecord.retailprice" value="{{ selectedCropRecord.retailprice }}" required />
            </div>
            <div class="form-group">
              <label for="wholesaleprice">WholeSale Price(UGX)</label>
              <input type="text" class="form-control change-input-field" placeholder="category" name="wholesaleprice" #wholesaleprice="ngModel"
              [(ngModel)]="selectedCropRecord.wholesaleprice" value="{{ selectedCropRecord.wholesaleprice }}" required />
            </div>
            <div class="d-flex justify-content-center align-item-center form-group">
              <button type="submit" class="submit-input-btn btn-success" >
                <span *ngIf="loadingModal" class="spinner-border spinner-border-md
                  text-white change-loading" role="status"></span>
                <span *ngIf="loading" class="mx-2">Loading...</span>
                <span *ngIf="!loading">
                  Save Info
                </span>
              </button>
            </div>
          </form>
            </div>
        </div>
      <div class="modal-footer">
        <a
        class="btn btn-danger text-white"
        data-dismiss="modal"
        data-toggle="modal"
        data-target="#selectedCropModal"
        (click)="prepareToDeleteInput(selectedCropRecord)"
        >Delete</a
        >
        <button type="button" class="btn btn-warning" data-dismiss="modal">
          <span class="text-white">CLOSE</span>
        </button>
      </div>
    </div>
    <app-success-modal
      *ngIf="openSuccessModal && message"
      [message]="message"
      (clearInputEvent)="clearInputId()"
    >
    </app-success-modal>
  </div>
</div>
<!-- Delete Input -->
<div class="modal fade" id="selectedCropModal">
  <div class="modal-dialog change-modal-dialog" role="document">
    <div class="modal-content" *ngIf="openDeleteModal">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Delete Record</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to delete {{ selectedCropRecord.commodity }} record
      </div>
      <div class="modal-footer">
        <span class="text-danger" *ngIf="errors">{{ errors }}</span>
        <button
          type="button"
          class="btn btn-danger"
          (click)="deleteInput(selectedCropRecord.id)"
        >
          <span
            *ngIf="loading"
            class="spinner-border spinner-border-md text-white
              update-loading"
            role="status"
          ></span>
          Delete Input
        </button>
        <button type="button" class="btn btn-outline-dark" data-dismiss="modal">
          Close
        </button>
      </div>
    </div>
    <!-- Modal -->
    <app-add-input
      *ngIf="openAddModal"
      (successEvent)="reloadInput()"
      (successMessage)="getMessage($event)"
    >
    </app-add-input>
    <app-edit-input
      [InputId]="InputId"
      *ngIf="InputId && openEditModal"
      (successEvent)="reloadInput()"
      (successMessage)="getMessage($event)"
    >
    </app-edit-input>
    <app-success-modal
      *ngIf="openSuccessModal && message"
      [message]="message"
      (clearInputEvent)="clearInputId()"
    >
    </app-success-modal>
  </div>
</div>
